import { Type } from "@sinclair/typebox";
import { DateTimeSchema, UserIdSchema } from "./auth.js";
export const AccountKeyResponseSchema = Type.Object({
    key: Type.String({ pattern: "^pk_account_v1_[0-9a-f-]{36}_[A-Za-z0-9_-]{43}$" }),
    keyId: UserIdSchema,
    orgId: UserIdSchema,
    createdAt: DateTimeSchema,
}, { additionalProperties: false });
export const RevokeAccountKeyResponseSchema = Type.Object({ revoked: Type.Literal(true) }, { additionalProperties: false });
//# sourceMappingURL=account-key.js.map